import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { fmtDate } from "@/lib/api";

export const DateField = ({ value, onChange, placeholder = "Pick a date", testId }) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button
        type="button"
        variant="outline"
        data-testid={testId}
        className="w-full justify-start font-normal rounded-lg"
      >
        <CalendarIcon className="mr-2 h-4 w-4 text-muted-foreground" />
        {value ? fmtDate(value) : <span className="text-muted-foreground">{placeholder}</span>}
      </Button>
    </PopoverTrigger>
    <PopoverContent className="w-auto p-0" align="start">
      <Calendar
        mode="single"
        selected={value ? new Date(value + "T00:00:00") : undefined}
        onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")}
      />
    </PopoverContent>
  </Popover>
);
